import React, { useEffect } from "react"
import { useProfileStore } from "stores"
import { H6 } from "components"

export const MatricProfile: React.FC<{}> = () => {
  const { matric, getMatric } = useProfileStore()

  useEffect(() => {
    getMatric()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className="flex flex-col gap-12 items-center">
      <div className="w-full flex flex-col gap-8">
        <div className="w-full flex flex-col gap-4">
          <div className="w-full p-4 bg-pryExtraLight">
            <H6 className="text-pryBase font-semibold">Matric Number</H6>
          </div>
        </div>

        <div className="w-full flex flex-col lg:flex-row gap-8 items-start">
          <div className="space-y-[5px] w-full">
            {/* <P2 className="text-accentGrey1 font-medium">Full Name</P2> */}
            <div className="w-full border-b-2 border-accentGrey3 bg-white p-3 text-accentText font-bold text-center">
              {matric}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
